{
  "questionnaire": {
    "welcomeIntro": "Ayúdenos a configurarlo respondiendo algunas preguntas rápidas",
    "step": "Paso",
    "steps": "Paso {{ currentStep }} de {{ totalSteps }}",
    "reason": {
      "question": "Cuéntanos qué te ha traído hoy a Iventis.",
      "options": {
        "SitePlanForMyEvent": "Para crear un plano de sitio para mi evento",
        "TeamPlanMoreEfficiently": "Descubre cómo mi equipo puede planificar de forma más eficiente",
        "PlanMultipleEventsPerProject": "Descubre cómo planificar varios eventos o proyectos",
        "JustCurious": "Solo por curiosidad"
      }
    },
    "eventType": {
      "question": "¿Y qué es lo que quieres planificar?",
      "options": {
        "SportsEvent": "Evento deportivo",
        "RoadEvent": "Evento itinerante",
        "FestivalOrParade": "Festival o desfile",
        "ExhibitionOrShow": "Exposiciones y conferencias",
        "MajorEvent": "Evento importante",
        "MultipleEvents": "Eventos múltiples",
        "Venue": "¿Un lugar",
        "SomethingElse": "¿Algo más"
      }
    },
    "experience": {
      "question": "¿Cuánta experiencia tiene con las herramientas de planificación?",
      "options": {
        "HaventUsedBefore": "No he usado ninguna antes",
        "Powerpoint": "¿Usó PowerPoint",
        "GoogleEarth": "Aplicaciones usadas como Google Earth",
        "GisAndCadSoftware": "Usó software GIS y CAD",
        "Iventis": "He usado Iventis anteriormente"
      }
    },
    "projectName": {
      "question": "Y, por último, ¿qué nombre tiene en mente para su proyecto actual?",
      "subLabel": "Sugerencia: este podría ser el nombre de tu evento o empresa.",
      "options": {
        "projectName": "Nombre del proyecto"
      },
      "label": "Introduzca un nombre para su proyecto:"
    },
    "skip": "Omitir por ahora",
    "ending_screen": {
      "initial_loading": {
        "message": "Solo estamos preparando las cosas para ti",
        "subtext": "Configurando su proyecto y analizando sus requisitos",
        "footerText": "Esto puede tardar unos segundos"
      },
      "taking_longer": {
        "message": "Está tardando un poco más de lo que esperábamos, ¡espera!",
        "subtext": "Mejorando nuestras herramientas para brindarle los resultados más nítidos",
        "footerText": "Esto puede tardar unos segundos"
      },
      "error": {
        "message": "Vaya, algo ha ido mal.",
        "subtext": "Parece que hay un problema de nuestra parte.",
        "footer_1": "Por favor",
        "footer_2": "para que podamos ayudarte a averiguar qué ha pasado."
      }
    },
    "setup_completed": "Configuración completada"
  },
  "passwordConditions": {
    "commonPassword": "La contraseña es demasiado simple. Por favor, prueba con algo más complejo."
  },
  "verification": {
    "headings": {
      "checkEmail": "Revisa tu correo electrónico",
      "emailVerified": "Correo electrónico verificado",
      "alreadyVerified": "¡Estás listo para irte"
    },
    "ctas": {
      "continueToLogin": "Continúe con el inicio de sesión",
      "resendEmail": "Haga clic para volver a enviar"
    },
    "noEmail": "¿No has recibido el correo electrónico?",
    "emailSent": "Hemos enviado un enlace de verificación a",
    "timerForResend": "en {{ time }} segundos",
    "accountVerifiedMessage": "Tu cuenta de correo electrónico ha sido verificada, haz clic en el botón de abajo para iniciar sesión.",
    "unverifiedErrorMessage": "No hemos podido verificar tu cuenta de correo electrónico. Ponte en contacto con nuestro equipo de soporte en",
    "alreadyVerifiedMessage": "Esta cuenta de correo electrónico ya se ha verificado. Haz clic en el botón de abajo para iniciar sesión."
  },
  "createAccount": {
    "free_trial": "Comience la prueba gratuita",
    "marketing": "Manténgame al día con las últimas noticias y actualizaciones",
    "iventisAccount": "¿Ya tienes una cuenta de Iventis?",
    "error": "Se ha producido un problema al crear su cuenta. Póngase en contacto con",
    "disableAdBlocker": "o intenta desactivar el bloqueador de anuncios e inténtalo de nuevo."
  },
  "logout": "Cierra sesión"
}